import React from 'react';
import { Link } from 'react-router-dom';

/**
 * LegalFooter Component
 * 
 * Display this component at the bottom of your main pages to provide
 * easy access to Privacy Policy and Terms of Service.
 */
const LegalFooter = ({ style = {} }) => {
  const defaultStyle = {
    padding: '8px 20px',
    background: 'rgba(15, 23, 42, 0.8)',
    borderTop: '1px solid rgba(148, 163, 184, 0.2)',
    textAlign: 'center',
    fontSize: '13px',
    color: '#94a3b8',
    ...style
  };

  const linkStyle = {
    color: '#60a5fa',
    textDecoration: 'none',
    margin: '0 10px',
    transition: 'color 0.2s'
  };

  const linkHoverStyle = {
    color: '#93c5fd',
    textDecoration: 'underline'
  };

  return (
    <footer style={defaultStyle}>
      <div style={{ marginBottom: '4px' }}>
        <Link 
          to="/privacy-policy" 
          style={linkStyle}
          onMouseOver={(e) => {
            e.target.style.color = linkHoverStyle.color;
            e.target.style.textDecoration = linkHoverStyle.textDecoration;
          }}
          onMouseOut={(e) => {
            e.target.style.color = linkStyle.color;
            e.target.style.textDecoration = 'none';
          }}
        >
          Privacy Policy
        </Link>
        <span style={{ color: '#475569' }}>•</span>
        <Link 
          to="/terms-of-service" 
          style={linkStyle}
          onMouseOver={(e) => {
            e.target.style.color = linkHoverStyle.color;
            e.target.style.textDecoration = linkHoverStyle.textDecoration;
          }}
          onMouseOut={(e) => {
            e.target.style.color = linkStyle.color;
            e.target.style.textDecoration = 'none';
          }}
        >
          Terms of Service
        </Link>
      </div>
      <div style={{ fontSize: '11px', color: '#64748b' }}>
        © {new Date().getFullYear()} AppleTree ESG Platform. All rights reserved.
        <br />
        Operated by Armando Dragoti (Pre-incorporation phase)
      </div>
    </footer>
  );
};

/**
 * Inline Legal Links (for compact display)
 * Use this in tight spaces like modals or sidebars
 */
export const InlineLegalLinks = () => (
  <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '8px' }}>
    By continuing, you agree to our{' '}
    <Link to="/privacy-policy" style={{ color: '#60a5fa', textDecoration: 'none' }}>
      Privacy Policy
    </Link>
    {' '}and{' '}
    <Link to="/terms-of-service" style={{ color: '#60a5fa', textDecoration: 'none' }}>
      Terms of Service
    </Link>
    .
  </div>
);

export default LegalFooter;
